import dayjs from "dayjs";

export const formatDateCell = (value?: Date | null) => {
	if (!value) return "";

	return dayjs(value).format("MM/DD/YYYY");
};